import {
  type EntityListOfUserQuestDetail,
  postUserQuestsOverview,
  type UserQuestListRequest,
  type UserQuestOverview,
} from "Infrastructure/Api/Api";
import {
  type ApiCallError,
  processResponse,
} from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";
import { userQuestKeys } from "./requestKeys";

interface UseUserQuestQueryOptions {
  userID?: number;
  offset?: number;
  limit?: number;
}

export const useUserQuestQuery = ({
  userID,
  offset = 0,
  limit = 100,
}: UseUserQuestQueryOptions = {}) => {
  const query: UserQuestListRequest = {
    offset,
    limit,
  };

  return useQuery<UserQuestOverview, ApiCallError, EntityListOfUserQuestDetail>(
    {
      queryKey: userQuestKeys.list({ userID, offset, limit }),
      queryFn: processResponse(({ signal }) =>
        postUserQuestsOverview(query, { signal }),
      ),
      select: (userQuestOverview) => userQuestOverview.userQuests,
    },
  );
};
